// 2026-10 · «Inventario y costes»: pestañas del hub, traducción de las rutas
// antiguas (Gestión › Dashboard / Operaciones ?tab=&sub=) y textos de motivos.
// Puro (sin React) para poder probarlo.

export const INVENTARIO_ADDON_NAME = "Escandallo y control de stock";

export const HUB_TABS = [
  { key: "inicio", label: "Inicio" },
  { key: "articulos", label: "Artículos" },
  { key: "recetas", label: "Recetas" },
  { key: "compras", label: "Compras" },
  { key: "stock", label: "Stock" },
  { key: "rentabilidad", label: "Rentabilidad" },
];

export const SECCIONES = {
  compras: [
    { key: "pedir", label: "Qué pedir" },
    { key: "pedidos", label: "Pedidos" },
    { key: "albaranes", label: "Albaranes" },
    { key: "incidencias", label: "Incidencias" },
    { key: "proveedores", label: "Proveedores" },
  ],
  stock: [
    { key: "actual", label: "Stock actual" },
    { key: "movimientos", label: "Movimientos" },
    { key: "inventarios", label: "Inventarios" },
  ],
  rentabilidad: [
    { key: "teorico", label: "Teórico vs real" },
    { key: "platos", label: "Por plato" },
    { key: "evolucion", label: "Evolución" },
    { key: "insights", label: "Consejos" },
    { key: "balance", label: "Balance" },
  ],
};

export const tabValida = (t) => (HUB_TABS.some((x) => x.key === t) ? t : "inicio");

export function seccionValida(tab, s) {
  const list = SECCIONES[tab];
  if (!list) return null;
  return list.some((x) => x.key === s) ? s : list[0].key;
}

/** Query string del hub: { tab, s, filtro }. */
export function hubSearch({ tab = "inicio", s, filtro } = {}) {
  const p = new URLSearchParams();
  p.set("tab", tabValida(tab));
  if (s) p.set("s", s);
  if (filtro) p.set("filtro", filtro);
  return `?${p.toString()}`;
}

// Operaciones: tab 0 Catálogo (Ingredientes, Elaboraciones, Recetas) ·
// tab 1 Compras (Proveedores, Sugerencias, Órdenes, Albaranes) · tab 2 Stock.
const OPERACIONES = [
  [{ tab: "articulos" }, { tab: "articulos", filtro: "elaboracion" }, { tab: "recetas" }],
  [
    { tab: "compras", s: "proveedores" },
    { tab: "compras", s: "pedir" },
    { tab: "compras", s: "pedidos" },
    { tab: "compras", s: "albaranes" },
  ],
  [
    { tab: "stock", s: "actual" },
    { tab: "stock", s: "movimientos" },
    { tab: "stock", s: "inventarios" },
  ],
];

/** `?tab=1&sub=3` de Operaciones → destino en el hub. */
export function desdeOperaciones(search = "") {
  const p = new URLSearchParams(search);
  const tab = Number(p.get("tab")) || 0;
  const sub = Number(p.get("sub")) || 0;
  const fila = OPERACIONES[tab] || OPERACIONES[0];
  return hubSearch(fila[sub] || fila[0]);
}

/** Dashboard antiguo (Resumen/Insights/Evolución/Rentabilidad) → Inicio o Rentabilidad. */
export function desdeDashboard(search = "") {
  const p = new URLSearchParams(search);
  const tab = Number(p.get("tab")) || 0;
  if (tab === 1) return hubSearch({ tab: "rentabilidad", s: "insights" });
  if (tab === 2) return hubSearch({ tab: "rentabilidad", s: "evolucion" });
  if (tab === 3) return hubSearch({ tab: "rentabilidad", s: "platos" });
  return hubSearch({ tab: "inicio" });
}

// Motivos que se registran a mano (StockMovimientoTipo.Manuales en el API).
export const MOTIVOS_AJUSTE = [
  { tipo: "salida_merma_preparacion", label: "Merma de preparación", ayuda: "Lo que se pierde al limpiar, pelar o cocinar.", merma: true },
  { tipo: "salida_merma_caducidad", label: "Caducado o estropeado", ayuda: "Género que se tira porque se ha pasado.", merma: true },
  { tipo: "salida_merma_manual", label: "Rotura u otra merma", ayuda: "Se ha caído, roto o tirado por otro motivo.", merma: true },
  { tipo: "salida_consumo_interno", label: "Consumo interno", ayuda: "Comida de personal, invitaciones, pruebas.", merma: false },
  { tipo: "salida_ajuste", label: "Corregir: hay menos", ayuda: "El stock del sistema es mayor que lo que hay.", merma: false },
  { tipo: "entrada_ajuste", label: "Corregir: hay más", ayuda: "Ha aparecido género que no constaba.", merma: false, entrada: true },
];

export const motivoAjuste = (tipo) => MOTIVOS_AJUSTE.find((m) => m.tipo === tipo) || null;

/** Cuerpo de POST gestion/stock/ajuste para un artículo del hub. */
export function cuerpoAjuste(articulo, { tipo, cantidad, notas }) {
  const motivo = motivoAjuste(tipo);
  const cant = Math.abs(parseFloat(String(cantidad ?? "").replace(",", ".")) || 0);
  const base = {
    cantidad: cant,
    tipo,
    esEntrada: Boolean(motivo?.entrada),
    notas: notas?.trim() || null,
  };
  return articulo?.tipo === "elaboracion"
    ? { ...base, idIngrediente: 0, idElaboracion: articulo.id }
    : { ...base, idIngrediente: articulo?.id };
}

/** Stock resultante tras el ajuste (para mostrar la consecuencia antes de confirmar). */
export function stockTras(articulo, { tipo, cantidad }) {
  const motivo = motivoAjuste(tipo);
  const cant = Math.abs(parseFloat(String(cantidad ?? "").replace(",", ".")) || 0);
  const actual = Number(articulo?.stockActual) || 0;
  return motivo?.entrada ? actual + cant : actual - cant;
}

/** Sugerencias de compra agrupadas por proveedor (las sin proveedor al final). */
export function agruparPorProveedor(sugerencias = []) {
  const map = new Map();
  sugerencias.forEach((s) => {
    const key = s.idProveedor || 0;
    if (!map.has(key)) map.set(key, { idProveedor: s.idProveedor || null, nombre: s.nombreProveedor || "Sin proveedor", lineas: [] });
    map.get(key).lineas.push(s);
  });
  return [...map.values()].sort((a, b) => {
    if (!a.idProveedor) return 1;
    if (!b.idProveedor) return -1;
    const ua = a.lineas.some((l) => l.urgente) ? 0 : 1;
    const ub = b.lineas.some((l) => l.urgente) ? 0 : 1;
    return ua - ub || a.nombre.localeCompare(b.nombre, "es");
  });
}

/** Importe estimado de un grupo de sugerencias (precio habitual × unidades de compra). */
export const importeGrupo = (lineas = []) =>
  lineas.reduce((acc, l) => acc + (Number(l.precioHabitual) || 0) * (Number(l.cantidadSugerida) || 0), 0);

/** Texto del contador del menú: «9+» a partir de 10. */
export const textoBadge = (n) => (!n || n <= 0 ? null : n > 9 ? "9+" : String(n));

export const formatEuros = (v, d = 2) =>
  `${(Number(v) || 0).toLocaleString("es-ES", { minimumFractionDigits: d, maximumFractionDigits: d })} €`;

export const formatCantidad = (v, unidad = "", d = 2) =>
  `${(Number(v) || 0).toLocaleString("es-ES", { maximumFractionDigits: d })}${unidad ? ` ${unidad}` : ""}`;

/**
 * Precio en la unidad en que se compra: g → €/kg, ml → €/l, el resto por su
 * unidad (ud, lata…). Null si no tiene precio.
 */
export function precioLegible(coste, unidad = "") {
  const c = Number(coste) || 0;
  if (c <= 0) return null;
  const u = String(unidad || "").trim().toLowerCase();
  if (u === "g" || u === "gr") return `${formatEuros(c * 1000)}/kg`;
  if (u === "ml") return `${formatEuros(c * 1000)}/l`;
  return `${formatEuros(c, c < 0.1 ? 3 : 2)}/${unidad || "ud"}`;
}

/** Cantidad inicial al elegir un artículo en una receta: 1 si se cuenta por unidades. */
export const cantidadInicial = (unidad = "") => {
  const u = String(unidad || "").trim().toLowerCase();
  return ["g", "gr", "ml", "kg", "l"].includes(u) ? "" : "1";
};

/**
 * Vuelta al hub desde una ficha: a la pestaña y filtro de donde se abrió
 * (location.state.volver), o al destino por defecto.
 */
export function volverDesde(location, porDefecto) {
  const v = location?.state?.volver;
  return typeof v === "string" && v.startsWith("/") ? v : porDefecto;
}
